import { useCallback } from 'react'

import { normalizeCommaSeparatedTextQuery } from '@/lib/list-filters/list-filter-params'

type UseUnifiedBrowseSearchOptions = {
  committedQ: string
  onUpdateQ: (q: string) => void
  normalizeQuery?: (value: string) => string
}

/**
 * Shared keyword commit/clear handlers for pages using `UnifiedListFilterBar`
 * with `keywordDisplay: 'inline'`. Comma-separated terms normalize to OR search.
 */
export function useUnifiedBrowseSearch({
  committedQ,
  onUpdateQ,
  normalizeQuery = normalizeCommaSeparatedTextQuery,
}: UseUnifiedBrowseSearchOptions) {
  const commitTextQuery = useCallback(
    (value: string) => {
      const normalized = normalizeQuery(value)
      if (!normalized) {
        if (committedQ) onUpdateQ('')
        return
      }
      if (normalized === normalizeQuery(committedQ)) return
      onUpdateQ(normalized)
    },
    [committedQ, normalizeQuery, onUpdateQ],
  )

  const clearCommittedTextQuery = useCallback(() => {
    if (!committedQ) return
    onUpdateQ('')
  }, [committedQ, onUpdateQ])

  return { commitTextQuery, clearCommittedTextQuery }
}
